import { APIClient } from "../api";
import { SolicitationFilter } from '../../models/SolicitationFilter';
import { SolicitationView } from "../../models/SolicitationView";
import { SolicitationFormResponseView } from "../../models/SolicitationFormResponseView";
import { SolicitationFilterV2 } from "../../models/SolicitationFilter";

export default class SolicitationService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    public statusListOptions: { value: string, label: string }[] = [
        { value: '111', label: 'Todas as situações' },
        { value: '102', label: 'Solicitações ativas exceto concluídas' },
        { value: '100', label: 'Situações ativas' },
        { value: '101', label: 'Situações inativas' },
        { value: '103', label: 'Situações pausadas' },
        { value: '1', label: 'Solicitações novas' },
        { value: '2', label: 'Solicitações em andamento' },
        { value: '3', label: 'Solicitações encaminhadas' },
        { value: '6', label: 'Solicitações canceladas' },
        { value: '7', label: 'Solicitações concluídas' },
        { value: '8', label: 'Solicitações encerradas' },
        { value: '9', label: 'Solicitações reabertas' },
        { value: '14', label: 'Solicitações em aprovação' },
    ];

    public statusList: { value: string, label: string }[] = [
        { value: '1', label: 'Nova' },
        { value: '2', label: 'Em andamento' },
        { value: '3', label: 'Encaminhada' },
        { value: '4', label: 'Parada' },
        { value: '5', label: 'Em pausa' },
        { value: '6', label: 'Cancelada' },
        { value: '7', label: 'Concluída' },
        { value: '8', label: 'Encerrada' },
        { value: '9', label: 'Reaberta' },
        { value: '10', label: 'Em planejamento' },
        { value: '11', label: 'Aguardando solicitante' },
        { value: '12', label: 'Aguardando atendimento' },
        { value: '13', label: 'Aguardando Outra Área' },
        { value: '14', label: 'Em aprovação' },
    ];

    public tipoDataList: { value: string, label: string }[] = [
        { value: '0', label: 'Solicitação' },
        { value: '1', label: 'Conclusão' },
        { value: '2', label: 'Encerramento' },
        { value: '3', label: 'Inicio Trabalho' },
        { value: '4', label: 'Termino Trabalho' },
        { value: '5', label: 'Data Registro Trabalho' },
    ];

    public attendantTypeList: { value: string, label: string }[] = [
        // { value: '0', label: 'Todos' },
        { value: '1', label: 'Atendente' },
        { value: '2', label: 'Gestor' },
    ];

    public urgency: { id: number, label: string, color: string }[] = [
        { id: 1, label: 'Normal', color: '#28A745' },
        { id: 2, label: 'Média', color: '#FFC107' },
        { id: 3, label: 'Alta', color: '#DC3545' },
        { id: 4, label: 'Crítica', color: '#343A40' },
    ]

    public workStatus: { id: number, label: string, icon: string }[] = [
        { id: 1, label: 'Novo', icon: 'ppi ppi-document-text' },
        { id: 2, label: 'Em andamento', icon: 'ppi ppi-in-progress' },
        { id: 3, label: 'Transferido', icon: 'ppi ppi-switch-horizontal' },
        { id: 4, label: 'Parado', icon: 'ppi ppi-pause' },
        { id: 5, label: 'Em pausa', icon: 'ppi ppi-pause' },
        { id: 6, label: 'Cancelado', icon: 'ppi ppi-trash' },
        { id: 7, label: 'Terminado', icon: 'ppi ppi-thumb-up' },
        { id: 8, label: 'Encerrada', icon: 'ppi ppi-in-progress' },
        { id: 11, label: 'Aguardando solicitante', icon: 'ppi ppi-pause' },
        { id: 12, label: 'Aguardando atendente', icon: 'ppi ppi-pause' },
        { id: 13, label: 'Aguardando outra área', icon: 'ppi ppi-pause' },
        { id: 14, label: 'Em aprovação', icon: 'ppi ppi-clock' },
        { id: 15, label: 'Aprovado', icon: "ppi ppi-thumb-up" },
        { id: 16, label: 'Reprovado', icon: "ppi ppi-thumb-down" }
    ]

    public processTypeList: { value: number, label: string }[] = [
        { value: 1, label: 'Incidente' },
        { value: 2, label: 'Requisição' },
        { value: 3, label: 'Demanda' },
        { value: 4, label: 'Mudança' },
        { value: 5, label: 'Consultoria' },
        { value: 6, label: 'Rotina' },
        { value: 7, label: 'Relacionamento' },
        { value: 8, label: 'Projeto' },
        { value: 9, label: 'Problema' },
        { value: 10, label: 'Ativação' },
        { value: 11, label: 'Implantação' },
    ]; 

    async getSolicitationGroupByUser(userId: number, idBusinessArea?: number) {
        const url = this.endpoint + `/Solicitation/SolicitationGroupByUser/${userId}?idBusinessArea=${idBusinessArea}`;
        return this.api({
            method: 'get',
            url
        });
    }

    async getSolicitationTemplates(userId: number) {
        const url = this.endpoint + `/Solicitation/GetTemplatesSolicitations/${userId}`;
        return this.api({
            method: 'get',
            url
        });
    }

    async getViewAdvancedMultiFilter(solicitationFilter: SolicitationFilter) {
        const url = this.endpoint + `/Solicitation/FilterSolicitante/${solicitationFilter.userId}/${solicitationFilter.idStatus}/${solicitationFilter.incidentId}/${solicitationFilter.dataInicio}/${solicitationFilter.dataFinal}/${solicitationFilter.TipoData}/${solicitationFilter.TipoSearch}/${solicitationFilter.Search}/${solicitationFilter.Top}?refresh=${Math.random()}`;
        
        return this.api({
            method: 'get',
            url
        });
    }

    async retrieveSolicitationsbyFilter(solicitationfilter: SolicitationFilter) {
        const url = `${this.endpoint}/Solicitation/Filter`;
        
        return this.api({
            method: 'post',
            data: solicitationfilter,
            url
        });
    }

    async deleteSolicitationTemplate(userId: number, solicitationId: number) {
        const url = this.endpoint + `/Solicitation/DeleteTemplateSolicitation/${userId}/${solicitationId}`;
        return this.api({
            method: 'get',
            url
        });
    }

    async GetFilterMultiAdvancedV2(solicitationFilter: SolicitationFilterV2) {
        if (solicitationFilter.attendantType == undefined) {
            solicitationFilter.attendantType = "0";
        }
        
        const url = this.endpoint
            + `/SolicitationAttendant/FilterMultiAdvancedV2?`
/*01*/ + `userid=${solicitationFilter.userId}`
/*02*/ + `&idsCustomer=${solicitationFilter.customerId}`
/*03*/ + `&idsTeam=${solicitationFilter.idTeam}`
/*04*/ + `&idsAttedent=${solicitationFilter.attendantId}`
/*05*/ + `&idsRequesters=${solicitationFilter.requesterId}`
/*06*/ + `&idsStatus=${solicitationFilter.idStatus}`
/*07*/ + `&searchText=${solicitationFilter.incidentId}`
/*08*/ + `&IdsGroupService=${solicitationFilter.IdsGroupService}`
/*09*/ + `&IdFilterField=${solicitationFilter.IdsFilterField}`
/*10*/ + `&IdsService=${solicitationFilter.IdsService}`
/*11*/ + `&dataInicio=${solicitationFilter.dataInicio}`
/*12*/ + `&dataFinal=${solicitationFilter.dataFinal}`
/*13*/ + `&TipoData=${solicitationFilter.TipoData}`
/*14*/ + `&Assunto=${solicitationFilter.assunto}`
/*15*/ + `&AttendantType=${solicitationFilter.attendantType}`

        return this.api({
            method: 'get',
            url
        });
    }

    async GetSLA(solicitationId: number) {
        const url = `${this.endpoint}/Solicitation/SLA?id=${solicitationId}`
        return this.api({
            method: 'get',
            url
        });
    }

    async GetDynamicFormData(solicitationId: number) {
        const url = `${this.endpoint}/Solicitation/GetDynamicFormData/${solicitationId}`
        return this.api({
            method: 'get',
            url
        });
    }

    async getViewSolicitationFinancial(solicitationId: number) {
        const url = `${this.endpoint}/Solicitation/Financial/${solicitationId}`
        return this.api({
            method: 'get',
            url
        });

    }

    async postSolicitationUpdate(solicitation: {
        id: number,
        idBusinessArea: number,
        idServiceGroup: number,
        idService: number,
        idProcess: number,
        idContract: number,
        idClassification: number,
        idClassificationGroup: number,
        idResponsibleUser: number,
        urgency: number,
        idOpenMode: number ,
        idUserRequester: number
    }) {

        const url = `${this.endpoint}/Solicitation/Update`;

        return this.api({
            data: solicitation,
            method: 'post',
            url
        });
    }

    async updateSubject(solicitationView: any) {
        const url = `${this.endpoint}/Solicitation/UpdateSubject`;

        return this.api({
            data: solicitationView,
            method: 'put',
            // headers: { "Content-Type": "application/json" },
            url
        });
    }

    async getById(solicitationsId: number) {
        const url = `${this.endpoint}/Solicitation/${solicitationsId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getTemplateAttendantSolicitations(userId: number) {
        const url = `${this.endpoint}/SolicitationAttendant/GetTemplateAttendantSolicitations/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async deleteTemplateAttendantSolicitation(userId: number, templateId: number) {
        const url = `${this.endpoint}/SolicitationAttendant/DeleteTemplateAttendantSolicitation/${userId}/${templateId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getSolicitationDetailById(solicitationId: number) {
        const url = `${this.endpoint}/Solicitation/Details/${solicitationId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async saveDynamicFormSolicitation(solicitationFormData: SolicitationFormResponseView) {
        const url = `${this.endpoint}/Solicitation/SaveDynamicForm/`;

        return this.api({
            data: solicitationFormData,
            method: 'post',
            url
        });
    }

    async SavePref(data: any) {
        const url = `${this.endpoint}/Solicitation/SavePref`;

        return this.api({
            data: data,
            method: 'post',
            url
        });
    }

    async GetPref(userId: any) {
        const url = `${this.endpoint}/Solicitation/GetPref/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }
}